// Saves from one tab run one at a time and read the questionnaire id and
// revision when they are sent, so a tab's own overlapping saves (page save,
// hidden-tab autosave, file upload) never trip the server's stale-revision
// check: only another device or tab can (ALDO-2759).
let queue: Promise<unknown> = Promise.resolve();

/** Runs `save` once every previously queued save has settled. */
export const enqueueQuestionnaireSave = <T>(
  save: () => Promise<T>,
): Promise<T> => {
  const next = queue.catch(() => undefined).then(save);
  queue = next;
  return next;
};
